var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.restricted
    ? _c(
        "div",
        { staticClass: "bypass" },
        [
          _c(
            "div",
            { staticStyle: { width: "fit-content", "padding-bottom": "32px" } },
            [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "heading" }, [
                _vm._v(
                  "\n      Replacement Eligibility Restriction Detected\n    "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "sub-heading" }, [
                _vm._v(
                  "\n      One or more restrictions prevent this action:\n    "
                ),
              ]),
              _vm._v(" "),
              _c("device-restriction-details", {
                staticClass: "restriction-list",
                attrs: {
                  "warranty-ends-at": _vm.warrantyEndsAt,
                  "oow-reason": _vm.oowReason,
                  restrictions: _vm.restrictions,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-card", { staticClass: "device-card" }, [
            _c(
              "div",
              { staticClass: "device-image" },
              [_c("DeviceImage", { attrs: { device: _vm.device } })],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "device-content" }, [
              _c("div", { staticClass: "device-name" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.device.profile.product.description) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "device-mac-id" }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.displayableDeviceId) + "\n      "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "device-status" }, [
                _vm.eligibility.isInWarranty
                  ? _c("span", [_vm._v("Out of warranty")])
                  : _c("span", [_vm._v("Restricted")]),
                _vm._v("\n        /\n        "),
                _c("span", [_vm._v("Not eligible for replacement.")]),
              ]),
            ]),
          ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "warning-img" }, [
      _c("img", {
        staticStyle: { height: "48px", width: "48px", "margin-bottom": "8px" },
        attrs: { src: require("../../../assets/warning-icon.svg") },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }